angular.module('core')
  .service('standard', ['$state', function ($state) {

      // Update state params with update timeframe value without causing a refresh.
      var updateStateParams = function (list) {
        var encodedParams = encodeParams(list);
        return $state.go('.', {'standards': encodedParams}, {location: 'replace', notify: false});
      };

      // Update state params with updated focusType value without causing a refresh.
      var updateFocusTypeParam = function (focusType) {
        $state.go('.', {'focusType': focusType}, {location: 'replace', notify: false});
      };

      // Reset standard and focusType state params without causing a refresh.
      var resetParams = function () {
        $state.go('.', {'focusType': null, 'standards': null}, {location: 'replace', notify: false});
      };

      // Convert name to given suffix.
      var nameToSuffix = function (name) {
        switch (name) {
          case 'grade':
            return 'g';

          case 'domain':
            return 'd';

          case 'standard':
            return 's';
        }
      };

      // Convert suffix to logical name.
      var suffixToName = function (suffix) {
        switch (suffix) {
          case 'g':
            return 'grade';

          case 'd':
            return 'domain';

          case 's':
            return 'standard';
        }
      };

      // Return suffix for current query timeframe param.
      // i.e. ...&timeframe=60d --> 'd'
      var getSuffix = function (timeframe) {
        var ret = false;
        ['g', 'd', 's'].forEach(function (suffix) {
          if (_.indexOf(timeframe, suffix) !== -1) {
            ret = suffix;
            return ret;
          }
        });

        return ret;
      };

      /* Encode params into comma separated string for query params
       * ( i.e. domain: 1, grade: 3, standard 18 --> g3,d1,s18 )
       */
      var encodeParams = function (list) {
        var encoded = [];
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (!_.isUndefined(item.id) && !_.isNull(item.id) && !_.isNaN(item.id)) {
            encoded.push(item.id + nameToSuffix(item.name));
          }
        }
        return encoded.toString();
      };

      /* Parse query params into an object
       * ( i.e. g3,d1,s18 --> { grade:3, domain:1, standard:18 } )
       */
      var getParams = function () {
        if (!$state.params.standards) {
          return {};
        }

        var standards = _.map($state.params.standards.split(','), function (item) {
          var suffix = getSuffix(item);
          var id = _.first(item.split(suffix));
          if (suffix && id) {
            return [suffixToName(suffix), parseInt(id)];
          }
        });

        if ($state.params.domain) {
          standards.push(['domain', $state.params.domain]);
        }
        if ($state.params.standardProficiency) {
          standards.push(['standardProficiency', $state.params.standardProficiency]);
        }

        return _.object(standards);
      };

      var getProficiencyStandard = function () {
        return $state.params.proficiencyStandard;
      };

      var getFocusType = function () {
        if (!$state.params.focusType) {
          return null;
        }

        var focusType = String($state.params.focusType).toLowerCase();
        return focusType;
      };

      /* Iterate through list of grades, domains, standards, if an object
       * exists that has the same id as in the query param add attribute
       * 'queryParamSelected' so we know which item to select.
       */
      var updateSelected = function (list, type) {
        var params = getParams();

        if (params[type] !== undefined) {
          var compare = (type === 'grade') ? {id: params[type]} : {code: '' + params[type]};
          var selected = _.findWhere(list, compare);

          if (selected) {
            selected.queryParamSelected = true;
          }
        }
        return list;
      };

      // Update selected item for grade list.
      var updateSelectedGrade = function (gradeList) {
        return updateSelected(gradeList, 'grade');
      };

      // Update selected item for domain list.
      var updateSelectedDomain = function (domainList) {
        return updateSelected(domainList, 'domain');
      };

      var updateSelectedStandard = function (standardList) {
        return updateSelected(standardList, 'standard');
      };

      //Convenience function to update state params.
      var updateState = function (state) {
        return updateStateParams([
          {name: 'grade', id: state.grade},
          {name: 'domain', id: state.domain},
          {name: 'standard', id: state.standard}
        ]);
      };

      // Do a hard reset of state params based on state attributes.
      var resetQueryParams = function (state) {
        return updateState(state);
      };

      // Only update state params that are specified in state - otherwise fallback on query params.
      var updateQueryParams = function (state) {
        var params = getParams();
        var updatedState = {
          grade: (_.isUndefined(state.grade) ? params.grade : state.grade),
          domain: (_.isUndefined(state.domain) ? params.domain : state.domain),
          standard: (_.isUndefined(state.standard) ? params.standard : state.standard)
        };
        updateState(updatedState);
      };

      // Return a url
      var generateHref = function (list) {
        var encodedParams = encodeParams(list);
        return $state.href('.', {pane: 'standards', standards: encodedParams});
      };

      return {
        updateStateParams: updateStateParams,
        getParams: getParams,
        getStandardFromProficiency: getProficiencyStandard,
        getFocusType: getFocusType,
        updateSelectedGrade: updateSelectedGrade,
        updateSelectedDomain: updateSelectedDomain,
        updateSelectedStandard: updateSelectedStandard,
        resetQueryParams: resetQueryParams,
        updateQueryParams: updateQueryParams,
        updateFocusTypeParam: updateFocusTypeParam,
        resetParams: resetParams,
        generateHref: generateHref
      };
    }
    ]
  );
